import React from 'react'
import { AvatarDropdown } from './header-avatar-dropdown';
import { MemberDropdown } from './header-member-dropdown';
import { UserDropdown } from './header-user-dropdown';
import { NavItem } from './header-nav-item';
import { Link } from 'react-router-dom';
import auth from '../utils/auth';
import { SuperadminDropdown } from './header-superadmin-dropdown';

const NavButton = ({children}) => <div className={`font-accent font-bold text-sm ml-8 px-5 py-1 border-2 cursor-pointer rounded`} style={{borderColor: '#ccc'}}>{children}</div>

const AuthButton = ({ small }) => {
  const { isOfficial, isVerified, isUser, isSuperadmin } = auth()

  if (isOfficial) {
    return <NavItem>
      <AvatarDropdown small={small}/>
    </NavItem>
  }
  else if (isSuperadmin) {
    return <NavItem>
      <SuperadminDropdown small={small}/>
    </NavItem>
  }
  else if (isVerified) {
    return <NavItem>
      <MemberDropdown small={small}/>
    </NavItem>
  }
  else if (isUser) {
    return <NavItem>
      <UserDropdown small={small}/>
    </NavItem>
  }
  else {
    return <React.Fragment>
      {
        small !== true &&
        <Link to="/login" className="login-button ml-8">
          <NavButton>Sign In</NavButton>
        </Link>
      }
      {
        small === true &&
        <Link to="/login" className="mr-1 login-button flex items-center justify-center ml-8">
          <h1 className="font-bold text-sm text-white uppercase">Sign In</h1>
        </Link>
      }
    </React.Fragment>
  }
}

export { AuthButton }
